<template>
  <div>
    <v-card class="text-xs-center mt-4" hover>
      <div class="compliance-badge">
        <v-badge overlap :value="vehicle.complianceCount > 0">
          <span slot="badge">{{ vehicle.complianceCount }}</span>
          <v-icon color="grey" class="ma-1" @click="goToCompliance()">{{ $store.state.global.pages.compliance.icon }}</v-icon>
        </v-badge>
      </div>

      <div class="card-actions">
        <v-btn
          flat
          icon
          color="grey"
          @click="edit = true"
          v-if="userAuthClass || allowInductionEntry"
        >
          <v-icon>edit</v-icon>
        </v-btn>
        <v-menu v-model="chooseChildPage" bottom offset-y>
          <v-btn flat icon color="grey" slot="activator">
            <v-icon>subdirectory_arrow_right</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile ripple @click="goToCompliance()">
              <v-list-tile-action>
                <v-icon :color="$store.state.global.pages.compliance.color">{{ $store.state.global.pages.compliance.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Show Compliance</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>

      <!-- <div class="">
                <v-avatar :color="color" size="66" class="overlap-avatar">
                    <span class="white--text headline">{{letter.toUpperCase()}}</span>
                </v-avatar>
      </div>-->
      <div class="pa-3" style="justify-content: center;">
        <div
          :class="color +' rounded vertical-center-container white--text headline overlap-avatar mx-auto'"
          style="height:65px; width:150px; justify-content: center;"
        >
          <!-- {{vehicle.name.slice(0,3) + ' - '+vehicle.name.slice(3,6)}} -->
          {{vehicle.name.substring(0, 10)}}
        </div>
      </div>

      <v-card-text @click="chooseChildPage = true">
        <div class="pb-3">
          <h5 class="subheading font-weight-regular text-capitalize">{{vehicle.name}}</h5>
          <div class="grey--text text-capitalize">
            <span class="clickable">{{vehicle.contractor.name}}</span>
          </div>
        </div>
        <div class="pb-3">
          <h5 class="subheading font-weight-regular grey--text text--darken-1">
            {{vehicle.vehicleType.name}}
            <span
              v-if="vehicle.vehicleType.tonnage > 0"
            >({{vehicle.vehicleType.tonnage}} tonne)</span>
          </h5>
          <div class="grey--text text-capitalize" v-if="!!vehicle.vin">
            <span class="clickable">VIN: {{vehicle.vin}}</span>
          </div>
        </div>
        <div>
          <div class="grey--text" v-if="!!vehicle.details">
            <span class="clickable">{{vehicle.details}}</span>
          </div>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat icon color="red lighten-3" @click="deleteDialog = true" v-if="userAuthClass">
          <v-icon>delete</v-icon>
        </v-btn>
      </v-card-actions>
      <slot name="parentActions"></slot>
      <div class="card-divider grey lighten-2" style="margin-top: 0px;"></div>

      <div class="card-footer text-xs-left">
        <time-ago class="grey--text" :subject="vehicle" :time="vehicle.updatedAt" needsParse updated>
          <v-icon small color="grey" slot="icon" class="mr-2">access_time</v-icon>
        </time-ago>

      </div>
      <div style="width: 100%; height: 2px;" :class="color"></div>
    </v-card>

    <!--EDIT VEHICLE DIALOG -->
    <v-dialog
      lazy
      v-model="edit"
      max-width="700px"
      @keydown.esc="edit = false"
      v-if="userAuthClass || allowInductionEntry"
    >
      <edit-vehicle :vehicle="vehicle" @close="edit = false" @vehicleEdited="displaySnack"></edit-vehicle>
    </v-dialog>

    <!-- DELETE CONFIRMATION DIALOG -->
    <v-dialog
      lazy
      v-model="deleteDialog"
      max-width="400px"
      @keydown.esc="deleteDialog = false"
      v-if="userAuthClass"
    >
      <v-card>
        <v-card-title class="headline">
          <span>
            Really delete?
            <span class="grey--text subheading">- {{vehicle.name}}</span>
          </span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" flat @click="deleteVehicle(); deleteDialog = false">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import VehicleService from "@/services/requests/vehicleService";
import getColorFromChar from "@/services/helpers/getColorFromChar";
import EditVehicle from "@/components/vehicles/editVehicle";
import DisplaySnack from "@/services/mixins/displaySnack";

export default {
  components: {
    EditVehicle
  },
  mixins: [DisplaySnack],
  data() {
    return {
      edit: false,
      deleteDialog: false,
      chooseChildPage: false
    };
  },
  methods: {
    deleteVehicle() {
      var vehicle = this.vehicle;
      VehicleService.deleteVehicle(vehicle.id)
        .then(result => {
          //console.log(result.data);
          this.$store.commit("vehicles/deleteFromArrayStateByValue", {
            prop: "vehicles",
            value: vehicle
          });
          this.snack({ text: "Vehicle was deleted!", color: "yellow" });
        })
        .catch(err => {
          //console.log("An error occured");
          this.snackError();
        });
    },
    goToCompliance() {
      this.model = "vehicle";
      this.subjectId = this.vehicle.id;
      this.contractorId = null;
      this.vehicleId = this.vehicle.id;
      this.driverId = null;
      this.$router.push({
        name: "compliance"
      });
    }
  },
  props: {
    vehicle: Object,
    index: Number
  },
  computed: {
    color() {
      return getColorFromChar(this.vehicle.name.charCodeAt(0));
    },
    letter() {
      return this.vehicle.name.charAt(0);
    },
    model: Store.getSet({ store: "compliance", prop: "model" }),
    subjectId: Store.getSet({ store: "compliance", prop: "subjectId" }),
    contractorId: Store.getSet({ store: "compliance", prop: "contractorId" }),
    vehicleId: Store.getSet({ store: "compliance", prop: "vehicleId" }),
    driverId: Store.getSet({ store: "compliance", prop: "driverId" })
  },
  components: {
    EditVehicle
  }
};
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
.overlap-avatar {
  margin-top: -48px;
  border: 6px solid #eee;
  border-color: #eee !important;
}

.rounded {
  border-radius: 10px;
}
.compliance-badge {
  position: absolute; 
  left: 13px; 
  top: 13px;
}
.card-actions {
  position: absolute; 
  right: 3px; 
  top: 3px;
}
</style>
